// extracted by mini-css-extract-plugin
export default {"con":"ProductDetailPage_con__2gk7a","detailPrdImg":"ProductDetailPage_detailPrdImg__-wVGq"};